import { AddCreditCard } from 'credit-cards'
import Modal from '@components/Modal'
import featureToggles from 'shared/featureToggles'

const AddCreditCardModal = ({ modalIndex = 1, onClose, isGuestFlow = false }) => {
    const closeModal = ({ forceClose } = { forceClose: false }) => {
        // This modal can have additional modals open.
        // Outside click handles all child modals as outside as well (due to React.Portal)
        // This checks if there are more modal open. If there is, onClose is ignored.
        // Only additional modals open, can be child modals.
        const modals = document.getElementsByClassName('modal-dropdown')
        if (modals.length === modalIndex || forceClose) {
            onClose()
        }
    }

    return (
        <Modal
            className={(featureToggles.brNeoPurchaseFlow || featureToggles.isColumbia) && 'modal--add-card'}
            onClose={closeModal}
            header={<T>subscription.purchase.label.add.card.modal</T>}>
            <AddCreditCard successCallback={closeModal} isGuestFlow={isGuestFlow} />
        </Modal>
    )
}

export default AddCreditCardModal
